import axios from 'axios'
import { authHeader } from '@/util/helpers'
import getEnv from '@/util/env'

const host = getEnv('VUE_APP_API_HOST')

const state = {
  assyst: [],
  ipaas: [],
  itom: [],
  assyst_problems: [],
  ipaas_problems: [],
  itom_problems: [],
  rest_bridges: [],
  itom_bridges: []
}

const mutations = {
  'GET_ASSYST' (state) {
    axios
      .get(
        `${host}/v2/assyst_software?include=assystProblems.fixed_in_assyst_software;contracts`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.assyst = response.data
      })
  },
  'GET_IPAAS' (state) {
    axios
      .get(
        `${host}/v2/ipaas_software?include=ipaasProblems.fixed_in_ipaas_software;contracts;rest_bridge;itom_bridge`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.ipaas = response.data
      })
  },
  'GET_ITOM' (state) {
    axios
      .get(
        `${host}/v2/itom_software?include=itomProblems.fixed_in_itom_software;contracts`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.itom = response.data
      })
  },
  'GET_ASSYST_PROBLEMS' (state) {
    axios
      .get(
        `${host}/v2/assyst_problems?include=fixed_in_assyst_software`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.assyst_problems = response.data
      })
  },
  'GET_IPAAS_PROBLEMS' (state) {
    axios
      .get(
        `${host}/v2/ipaas_problems?include=fixed_in_ipaas_software`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.ipaas_problems = response.data
      })
  },
  'GET_ITOM_PROBLEMS' (state) {
    axios
      .get(
        `${host}/v2/itom_problems?include=fixed_in_itom_software`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.itom_problems = response.data
      })
  },
  'GET_REST_BRIDGES' (state) {
    axios
      .get(
        `${host}/v2/bridges/rest`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.rest_bridges = response.data
      })
  },
  'GET_ITOM_BRIDGES' (state) {
    axios
      .get(
        `${host}/v2/bridges/itom`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.itom_bridges = response.data
      })
  },
}

const getters = {
  assyst: state => {
    return state.assyst
  },
  ipaas: state => {
    return state.ipaas
  },
  itom: state => {
    return state.itom
  },
  assyst_problems: state => {
    return state.assyst_problems
  },
  ipaas_problems: state => {
    return state.ipaas_problems
  },
  itom_problems: state => {
    return state.itom_problems
  },
  rest_bridges: state => {
    return state.rest_bridges
  },
  itom_bridges: state => {
    return state.itom_bridges
  },
}

const actions = {
  load ({ commit }) {
    commit('GET_ASSYST')
    commit('GET_IPAAS')
    commit('GET_ITOM')
    commit('GET_ASSYST_PROBLEMS')
    commit('GET_IPAAS_PROBLEMS')
    commit('GET_ITOM_PROBLEMS')
    commit('GET_REST_BRIDGES')
    commit('GET_ITOM_BRIDGES')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
